import { z } from 'zod';
/**
 * Décodeur tolérant pour les frontières d'E/S : corps d'erreur HTTP, charge utile
 * JWT décodée, JSON d'un prestataire, état persisté dans le navigateur. La valeur
 * conforme à `schema` ressort telle quelle, toute autre forme devient `undefined`.
 *
 * Le champ mal formé est ainsi isolé : contrairement à un `z.object()` strict, un
 * seul champ inattendu ne fait pas perdre les champs voisins, qui eux sont
 * exploitables. À réserver aux entrées qu'on ne maîtrise pas — un contrat interne
 * doit être validé en bloc, et échouer bruyamment s'il ne l'est pas.
 */
export const lenient = (schema) => z.unknown().transform((value) => {
    const parsed = schema.safeParse(value);
    return parsed.success ? parsed.data : undefined;
});
